<template>


<div>
  <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show" :timeout="1000" top>
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" 
        
        :is-full-page="fullPage"></loading>
        <b-modal ref="my-modal" class="text-center" hide-footer title="Are you sure you want to remove this items ?">
      <div class="d-block text-center">
        <h3 style="font-size: 19px;"></h3>
      </div>
      
      <v-row no-gutters style="text-align:center;">

         <!-- <v-col cols="12" sm="6" md="3">
    <b-form-textarea
    size="sm" 
      id="textarea"
      v-model="reason"
      placeholder="Reason for the cancelation"
      rows="3"
      max-rows="6"
    ></b-form-textarea>

   </v-col> -->
            <v-col cols="6"  sm="4" >
               <b-button size="sm" class="mt-2" style="margin-right:5px;" variant="outline-danger" block @click=" hideModal()">Cancel</b-button>
            </v-col>
            
             <v-col cols="6"  sm="4" >
                <b-button size="sm" class="mt-2" style="margin-left:5px;" variant="outline-success" block @click="emptywishlist()" >Ok</b-button>
            </v-col>
      </v-row>
     
     
    </b-modal>
<v-container class="grey lighten-5">
    
    <v-row dense
    >
    
    <v-col
    
          v-for="(item, i) in myArray"
          :key="i"
          cols="6"
        >
       
     <v-card  light style="color:grey" >
       <div id="titl" style="background: #f0f0f0;">
          <b style="font-size: 10px;"
                  class="headline cs"
                > {{item.ItemName}}</b><br>
                <b style="font-size: 10px;"
                  class="headline cs"
               > {{item.ArabicName}}</b>
       </div>
       <div @click="openitem(item.Barcode)">
            <v-avatar
                class="ma-3"
                size="125"
                tile
              >
                <v-img :src="imgURL+item.ItemCode+'.jpg'" :id="item.Barcode"  @error="setAltImg(item.Barcode)"  :alt="item.ItemCode+'.jpg'" ></v-img>
              
               
              </v-avatar>
            
               <v-card-title style="color: #ffc107;"
                  class="headline"
                 
                ><span style="color:#000;font-size:15px;">{{currency}}&nbsp;</span>{{formatPrice(item.SellingRate) }}</v-card-title>
       </div>
    <v-row no-gutters>
      <v-col cols="4" :id="item.SellingRate"  @click="del(i,)" >
        <v-btn icon >
          <v-icon :id="item.Barcode+item.ItemName" style="color:red">mdi-heart</v-icon>
        </v-btn>
      </v-col>
      <v-col class="4" :id="item.SellingRate"  @click="adcart(item.ItemName,i,item.Barcode,item.ArabicName)">
              <v-btn icon  >
                <v-icon :id="item.Barcode+item.ArabicName">mdi-cart</v-icon>
                
              </v-btn>
      </v-col>
    
      <v-col class="4">
              <v-btn icon>
                 <a :href="link+item.Barcode"
            target="_blank"> 
          
        <v-icon>mdi-share-variant</v-icon> </a>
              </v-btn>
     </v-col>
    </v-row>
     </v-card>
    </v-col>
      
     
         
       
    </v-row>
  </v-container>
 <div  v-if="myArray" class="text-center" style="padding:25px 3px 25px 3px">
        <v-btn v-on:click="confirmDel()" block color="#FF0000" dark >REMOVE MY WISHLIST</v-btn>
  </div>
<div v-if="!myArray" class="mx-auto" style="margin-top:10rem"> 
<div><img :src="notfound">
</div>

  <div class="text-center text-danger" >Wishlist is Empty</div>
  <div class="text-center " style="margin-top:1rem">
   <v-btn   to="/" style="background:#009900; color:#fff; hight:100%">
      Continue Shopping
    </v-btn>
   </div>
 </div>
  
  </div>
  
</template>

<script>

import Vue from 'vue'
 import axios from 'axios';
 import Loading from 'vue-loading-overlay';
    // Import stylesheet
 import Router from '../router';
 import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components: {
            Loading
        },
    data: () => ({
       link: "https://api.whatsapp.com/send?text=https://sitenewn.firebaseapp.com/?Barcode=",
       imgURL:'',
      currency:'',
      isLoading: false,
      fullPage: true,
      scrolledToBottom: 1,
      products : [],
      scrollproducts : [],
      seen :true,
      seenid:'',
      cartlist:[],
      wishlist:[],
      text: '',
      timeout: 1500,
      scrcount : 1,
      colorcount:0,
      cartitem:[],
      wishitem:[],
      myArray : [],
      test:[],
      firstload:'',
      loopcart:'',
      snackbar: {
                show: false,
                message: null,
                color: null
            },
      clicked: [],
      notfound:"https://img.icons8.com/clouds/2x/favorite-cart.png",
       wishclicked: [],
      cartcolorbar:[],
      items: [
        {
          color: '#1F7087',
          src: 'https://demo.w3layouts.com/demos_new/template_demo/20-07-2017/grocery_store-demo_Free/725976873/web/images/1.png',
          title: 'Fortune Sunflower Oil',
          price: '₹117.99',
          id:'2145'
        },
        {
          color: '#1F7087',
          src: 'https://demo.w3layouts.com/demos_new/template_demo/20-07-2017/grocery_store-demo_Free/725976873/web/images/2.png',
          title: 'Pepsi Soft Drink (2 Ltr)',
          price: '₹60.00',
          id:'2155'
        },
        
        {
         color: '#1F7087',
          src: 'https://demo.w3layouts.com/demos_new/template_demo/20-07-2017/grocery_store-demo_Free/725976873/web/images/3.png',
          title: 'Rice (5kg)',
          price: '₹517.00',
          id:'2165'
        },
        {
          color: '#952175',
          src: 'https://demo.w3layouts.com/demos_new/template_demo/20-07-2017/grocery_store-demo_Free/725976873/web/images/4.png',
          title: 'Dog Food',
          price: '₹231.00',
          id:'2175'
        },
        
      ],
    }),

    watch: {
    scrcount: function(newValue, oldValue) {
     console.log(newValue+" "+oldValue)
   
    }
    },

    mounted() {
       this.imgURL = localStorage.getItem("imgUrl");
   this.currency = localStorage.getItem("currency");
   this.decimalPlaces=localStorage.getItem("decimalPlaces");
     this.wishclicked = JSON.parse(localStorage.getItem("wishclicked"))

     this.test = JSON.parse(localStorage.getItem("cartlist"));
    this.myArray = JSON.parse(localStorage.getItem("wishlist"));
    
  
     this.getPrimaryCurrency();
      
    
   
    this.$parent.$children[0].$parent.$parent.itemcountnumber = localStorage.getItem('countitemno');
    
    setTimeout(this.setcartcolor, 5000)
    },
    methods: {
      formatPrice(value) {
        const val = (value/1).toFixed(  this.decimalPlaces);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
      setAltImg(bar) { 
        console.log("aa "+bar)
         document.getElementById(bar).style.backgroundImage = "url('http://resource.linkwayapps.com/dkhm/itemimages/ItemImage.jpg')";
         document.getElementById(bar).style.backgroundPosition = "center center";
          document.getElementById(bar).style.backgroundSize = "cover"
       
     }, 



        //remove wishlist 

del (index ){
      // this.arr.splice(index, 1)
      // this.$delete(this.myArray, index)
      console.log(index)
    // this.myArray.splice(index,this.i)
      
      this.wishclicked.splice(index,1); 
      console.log(JSON.stringify(this.wishclicked));
      localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked));
      // localStorage.setItem(this.myArray);
       this.myArray.splice(index,1);
      localStorage.setItem("wishlist", JSON.stringify(this.myArray));
       this.snackbar = {
                        message: 'Item Remove from wishlist',
                        color: 'success',
                        show: true
                    }
       if(this.myArray.length===0)
   {
    //   window.localStorage.removeItem("cartcount");
      window.localStorage.removeItem("wishlist");
       window.localStorage.removeItem("wishclicked");
      location.reload();
   }
       },
       confirmDel()
      {
        // localStorage.setItem("delpos",del);
        // localStorage.setItem("orderId",orderId);
       
        this.$refs['my-modal'].show()
         
        
    
      },
      hideModal() {
        this.$refs['my-modal'].hide()
       },


       emptywishlist()
{
      window.localStorage.removeItem("wishcount");
      window.localStorage.removeItem("wishlist");
      window.localStorage.removeItem("wishclicked");
      location.reload();
},

        //-------------------=========================------------

      setcartcolor: function(){
           if(localStorage.getItem("carclicked")!== null)
    {
      
      this.loopcart = JSON.parse(localStorage.getItem("carclicked"));
      

      for(this.i=0;this.i<this.loopcart.length; this.i++)
        {
           console.log("ok"+this.loopcart[this.i])
          
          this.var = this.loopcart[this.i]

          document.getElementById(this.loopcart[this.i]).style.color = '#009900';
            
          
        
        }
         
     
    }
      },
      

     

      openitem : function(brcd)
      {
          
          Router.push('/singleitem');
          localStorage.setItem("barcode", brcd);
         
      },
      
      //------------------------------------------
 getPrimaryCurrency: function () {
      axios.get(this.$bURL+"Currency/GetPrimaryCurrency")
      .then((response)  =>  {
       // console.log(response.data)
        localStorage.setItem('decimalPlaces', response.data.DecimalPlaces);
        setTimeout(() => {
                  this.isLoading = false
         },1000)
      }, (error)  =>  {
          console.log(error)
      })
    },



   //cart Adding Function
   adcart: function (name,pos,bar,arb) {

     if (localStorage.getItem("carclicked") === null) {
  
      this.clicked.push(bar+arb)
     localStorage.setItem("carclicked",JSON.stringify(this.clicked))
       }else{
            this.clicked = JSON.parse(localStorage.getItem("carclicked"))
         this.clicked.push(bar+arb)
          localStorage.setItem("carclicked",JSON.stringify(this.clicked))
       
       }


     
     console.log("id "+ name+" pos "+pos)
      document.getElementById(bar+arb).style.color = '#009900';
    // if(this.cartlist.includes(this.scrollproducts[pos])) {
          
    //       alert("already there");
          
    //     }else{
      this.cart =JSON.parse(localStorage.getItem("cartlist"))
      if(this.cart!=null || this.cart!=undefined)
      {
            this.cartlist = this.cart;
      }
            
         this.flag=false; 
          this.flagid='';
       if(this.cartlist!=null || this.cartlist!=undefined)
       {
          for(this.i=0;this.i<this.cartlist.length;this.i++)
           {
             if( this.cartlist[this.i].Barcode===this.myArray[pos].Barcode)
             {
               this.flag=true; 
               this.flagid=this.i; 
               break;
             }
           }
           if(this.flag===true)
           {
             console.log(this.cartlist[this.flagid].count);
             this.cartlist[this.flagid].count+=1
           }
           else{
             this.myArray[pos].count=1;
             this.cartlist.push(this.myArray[pos]);
           }
       }
      else {
          this.cartlist.push(this.myArray[pos]);
       }
    
      // this.cartlist.push(this.scrollproducts[pos]);
          this.cartitem = this.cartlist;
           this.$parent.$children[0].$parent.$parent.addedcartitem = this.cartlist;
        localStorage.setItem("cartlistarray",JSON.stringify(this.cartlist))
        localStorage.setItem("cartcount",this.cartlist.length)
         this.$parent.$children[0].$parent.$parent.itemcountnumber = this.cartlist.length;
        localStorage.setItem("cartlist", JSON.stringify(this.cartlist));

        this.snackbar = {
                        message: 'Item Added Successfully',
                        color: 'success',
                        show: true
                    }
        // }
      

     
   
    },
    //wishlist adding function
     addwishlist: function (name,pos,bar) {



       if (localStorage.getItem("wishclicked") === null) {
  
        this.wishclicked.push(bar+pos)
       localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked))
    
       }else{
            this.wishclicked = JSON.parse(localStorage.getItem("wishclicked"))
          this.wishclicked.push(bar+pos)
       localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked))
       
       }


    
     console.log("id "+ name+" pos "+pos)
     
     document.getElementById(bar+pos).style.color = 'red';
    
    // if(this.cartlist.includes(this.scrollproducts[pos])) {
          
    //       alert("already there");
          
    //     }else{
      this.wish =JSON.parse(localStorage.getItem("wishlist"))
      if(this.wish!=null || this.wish!=undefined)
      {
            this.wishlist = this.wish;
      }
            
         this.flag=false; 
          this.flagid='';
       if(this.wishlist!=null || this.wishlist!=undefined)
       {
          for(this.i=0;this.i<this.wishlist.length;this.i++)
           {
             if( this.wishlist[this.i].Barcode===this.scrollproducts[pos].Barcode)
             {
               this.flag=true; 
               this.flagid=this.i; 
               break;
             }
           }
           if(this.flag===true)
           {
             console.log(this.wishlist[this.flagid].count);
             this.wishlist[this.flagid].count+=1
           }
           else{
             this.scrollproducts[pos].count=1;
             this.wishlist.push(this.scrollproducts[pos]);
           }
       }
      else {
          this.wishlist.push(this.scrollproducts[pos]);
       }
    
      // this.cartlist.push(this.scrollproducts[pos]);
          this.wishitem = this.wishlist;
          //  this.$parent.$children[0].$parent.$parent.addedwishitem = this.wishlist;
        // localStorage.setItem("wishlistarray",JSON.stringify(this.wishlist))
        // localStorage.setItem("wishcount",this.wishlist.length)
        //  this.$parent.$children[0].$parent.$parent.itemcountnumber = this.wishlist.length;
        localStorage.setItem("wishlist", JSON.stringify(this.wishlist));

        this.snackbar = {
                        message: 'Item is added to My Wishlist',
                        color: 'success',
                        show: true
                    }
        // }
      

     
   
    },
    
  
  
  
    }
    


}
</script>
<style scoped>
.v-card__title {
    align-items: center;
    display: block ;
}
.cs{
  padding-left: 5px;
  padding-right: 5px;
   display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis; 
}
.v-snack__wrapper {
    align-items: center;
    background-color: #28a745 !important;
    border-radius: 25px;
}
.v-snack .v-snack--active{
 background-color: #28a745 !important;
}
.snackbar{
  background-color:black;
}
</style>